import { Controller } from "@hotwired/stimulus"
import { readBest } from "../utils/arcade_stage"

// La salle tient deux affichages à jour :
//
//   - le record PERSONNEL de chaque borne, qui vit dans le `localStorage` du navigateur — le
//     serveur rend un tiret, il ne sait pas ce qu'il y a dedans ;
//   - le tableau des records, qui vit en base et arrive dans son propre turbo-frame.
//
// Les deux se rafraîchissent à la fin d'une partie : elle se joue derrière un overlay, sans
// la moindre navigation, donc rien ne le signalerait autrement.
const FRAME = "turbo-frame#arcade_leaderboard"

export default class extends Controller {
  static values = { leaderboardUrl: String }

  connect() {
    this.refresh()
    this.onLoad = () => this.refresh()
    // Le tableau de bord est la seule page mise en cache par Turbo : au retour dessus, le
    // corps restauré porte les records d'avant la partie.
    document.addEventListener("turbo:load", this.onLoad)
    document.addEventListener("arcade:finished", this.onLoad)
  }

  disconnect() {
    document.removeEventListener("turbo:load", this.onLoad)
    document.removeEventListener("arcade:finished", this.onLoad)
  }

  refresh() {
    const format = new Intl.NumberFormat(document.documentElement.lang || "fr")

    this.element.querySelectorAll("[data-arcade-best]").forEach((node) => {
      const best = readBest(node.dataset.arcadeBest)
      if (best <= 0) return

      // Le tape-taupe compte des euros recouvrés : un record sans son unité se lirait comme
      // un nombre de coups.
      const unit = node.dataset.arcadeBestUnit
      node.textContent = unit ? `${format.format(best)}\u00a0${unit}` : format.format(best)
    })

    this.#reloadLeaderboard()
  }

  #reloadLeaderboard() {
    const frame = this.element.querySelector(FRAME)
    if (!frame || !this.hasLeaderboardUrlValue) return
    // Pas encore chargé : le frame est paresseux, il ira le chercher tout seul en arrivant à
    // l'écran. Le recharger ici annulerait justement ce qu'on voulait différer.
    if (!frame.complete) return

    // Le fragment renvoyé par le serveur ne porte pas de `src`, et Turbo n'en garde pas non
    // plus après le premier chargement : `reload()` seul n'aurait plus d'adresse à
    // rappeler. On la repose, et on retire le témoin de complétude pour que le frame reparte.
    frame.removeAttribute("complete")
    frame.src = this.leaderboardUrlValue
    if (typeof frame.reload === "function") frame.reload()
  }
}
